<template>
    <!-- <div class="login">
		<div class="login-con">
			<Card icon="log-in" title="欢迎登录" :bordered="false">
				<div class="form-con">
					<login-form @on-success-valid="login"></login-form>
				</div>
			</Card>
		</div>
  	</div> -->
	<div class="login">
		<div class="logo">
			<img class="logoPic" src="../../static/img/logo.png" alt="">
				<p class="title">医学影像云平台</p>
		</div>
		<div class="content">
			<div class="login-con">
				<Card icon="log-in" title="欢迎登录" :bordered="false">
					<div class="form-con">
						<login-form @on-success-valid="login"></login-form>
					</div>
				</Card>
			</div>
		</div>
		<div class="footer">
			<span>售后电话：029-89182669</span>
			<span>技术支持：西安诸子信息技术有限责任公司</span>
		</div>
  	</div>
</template>

<script>
import LoginForm from "../components/Login/LoginForm"
import Cookies from "js-cookie";
export default {
    components:{
        LoginForm
    },
    methods:{
        login(value){
            this.$api.login.login(value).then((res)=> {
                if(res && res.code === 0){
                    Cookies.set('token', res.token) // 放置token到Cookie 
                    window.sessionStorage.setItem('token',res.token)
                    sessionStorage.setItem('user', JSON.stringify(res.user)) // 保存用户到本地会话
                    // this.$router.push('/remoteImageCenter')  // 登录成功，跳转到主页
                    let data={
                      t:new Date().getTime()
                    }
                    return this.$api.menu.getMenuList(data)
                }else{
                  	this.$Message.error(res.msg);
                }
            }).then(res => {
              if(res&&res.menuList) {
                this.$router.push('/' + res.menuList[0].url)
              }
            }).catch((res)=> {
                console.log(res);
            });
		}
    }
}
</script>

<style lang="scss" scoped>
//     .login{
//     width: 100%;
//     height: 100%;
//     background-image: url('../../static/img/login-bg.jpg');
//     background-size: cover;
//     background-position: center;
//     position: relative;
//     &-con{
//       position: absolute;
//       right: 160px;
//       top: 50%;
//       transform: translateY(-60%);
//       width: 300px;
//       &-header{
//         font-size: 16px;
//         font-weight: 300;
//         text-align: center;
//         padding: 30px 0;
//       }
//       .form-con{
//         padding: 10px 0 0;
//       }
//     }
//   }
.login{
		width: 100%;
		height: 100%;
		background: #199fcf;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.logo{
			width: 1000px;
			height: 100px;
			position: absolute;
			top: 40px;
			left: 55px;
			.logoPic{
				// width: 100%;
				// height: 100%;
				width: 250px;
				height: 100px;
			}
			.title{
				position: absolute;
				top: 0;
				left: 260px;
				line-height: 100px;
				color: #fff;
				font-size: 24px;
			}
		}
		.footer{
			height: 40px;
			background: #0185b5;
			text-align: center;
			line-height: 40px;
			font-size: 14px;
			color: #fff;
		}
		.content{
			max-width: 100%;
			width: 1280px;
			height: 100%;
			margin: 0 auto;
			background-image: url('../../static/img/bg.png');
			background-size: contain;
			background-repeat: no-repeat;
			overflow: hidden;
			background-position-y: bottom;
			.tagCloud{
				position: absolute;
				width: 500px;
				height: 500px;
				top: 300px;
				left: 0;
			}
		}
		&-con{
			position: absolute;
			right: 160px;
			top: 50%;
			transform: translateY(-60%);
			width: 300px;
			&-header{
				font-size: 16px;
				font-weight: 300;
				text-align: center;
				padding: 30px 0;
			}
			.form-con{
				padding: 10px 0 0;
			}
		}
  }
</style>



// WEBPACK FOOTER //
// src/page/Login.vue